import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  description: string;
  action?: ReactNode;
}

export function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className="rounded-md border border-dashed border-forest/20 bg-bone/50 p-8 text-center">
      <h3 className="text-sm font-semibold text-forest">{title}</h3>
      <p className="mt-1 text-sm text-forest/60">{description}</p>
      {action ? <div className="mt-3">{action}</div> : null}
    </div>
  );
}
